import { PrismicLink } from '@prismicio/react'
import { PrismicNextImage } from '@prismicio/next'
import NavbarDropdownIcon from '@/components/navbar/NavbarDropdownIcon'
import NavbarChevronRight from '@/components/navbar/NavbarChevronRight'

type DataObject = Record<string, any>
type ItemObject = Record<string, any>

const PartnersDropdownData = ({ data }: { data: DataObject }) => {
  return (
    <div className="dropdown-menu">
      <div className="container-fluid">
        <div className="dropdown-menu-wrapper">
          <div className="audit-partners-nav-content col-span-5">
            <div>
              <h4 className="mb-6">{data.audit_partner_text}</h4>

              <div className="audit-partners-nav-content-items">
                {data.audit_partners.map((item: ItemObject, index: number) => {
                  const key = `i-${index}`
                  return (
                    <PrismicLink field={item.audit_partners_link_url} key={key}>
                      <div className="audit-partners-nav-content-item">
                        <NavbarDropdownIcon field={item.audit_partners_icon} />

                        <div className="flex flex-col gap-1">
                          <span className="block font-halyardDisplay text-base font-medium !leading-[110%] tracking-[0.16px] text-primary-ink-100">
                            {item.audit_partners_title}
                          </span>
                          <span className="block text-base font-normal !leading-[150%] tracking-[0.16px] text-primary-ink-85">
                            {item.audit_partners_description}
                          </span>
                        </div>
                      </div>
                    </PrismicLink>
                  )
                })}
              </div>
            </div>
          </div>

          <div className="partners-program-nav-content col-span-2">
            <h4 className="mb-6">{data.become_a_partner_text}</h4>

            <div className="partners-program-nav-content-items">
              {data.partners_portals.map((item: ItemObject, index: number) => {
                const key = `i-${index}`
                return (
                  <PrismicLink field={item.partners_portals_link_url} key={key}>
                    <div className="partners-program-nav-content-item">
                      <NavbarDropdownIcon field={item.partners_portals_icon} />

                      <div className="btn-interaction flex items-center gap-2 leading-none">
                        <span className="font-halyardDisplay text-base font-medium tracking-[0.16px] text-primary-ink-100">
                          {item.partners_portals_title}
                        </span>
                        <NavbarChevronRight />
                      </div>
                    </div>
                  </PrismicLink>
                )
              })}
            </div>
          </div>

          <div className="partners-portals-nav-content col-span-2">
            <div className="partners-portals-nav-content-items">
              {data.gap_assessment?.map((item: ItemObject, index: number) => {
                const key = `i-${index}`
                return (
                  <div className="partners-portals-nav-content-item" key={key}>
                    <PrismicNextImage field={item.gap_assessment_logo} loading="lazy" fallbackAlt="" />
                    <div className="mt-2 flex flex-col gap-1">
                      <span className="block font-halyardDisplay text-base font-medium !leading-[150%] tracking-[0.16px] text-primary-ink-100">
                        {item.gap_assessment_title}
                      </span>
                      <span className="block min-h-[50px] text-base font-normal !leading-[150%] tracking-[0.16px] text-primary-ink-85">
                        {item.gap_assessment_description}
                      </span>
                    </div>

                    <PrismicLink field={item.gap_assessment_btn_link}>
                      <div className="btn-interaction mt-8 flex items-center gap-2 leading-none">
                        <span className="font-halyardDisplay text-base font-medium tracking-[0.16px] text-primary-ink-100">
                          {item.gap_assessment_btn_label}
                        </span>
                        <NavbarChevronRight />
                      </div>
                    </PrismicLink>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PartnersDropdownData
